import DBConfig from 'webmango-db'

export default DBConfig()



// WEBPACK FOOTER //
// ./src/db.js